document.addEventListener('DOMContentLoaded', function () {
  const updateViewportHeight = (isInitial) => {
    const viewportHeight = window.innerHeight;
    document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);
    if (isInitial) {
      document.documentElement.style.setProperty('--initial-viewport-height', `${viewportHeight}px`);
    }
  };
  updateViewportHeight(true);
  window.addEventListener('resize', () => updateViewportHeight(false));

  const elements = {
    quickViewPopup: document.getElementById('quick-view-popup'),
    quickViewContent: document.getElementById('quick-view-content'),
    quickViewLoader: document.getElementById('quick-view-loader'),
    quickViewOverlay: document.querySelector('.quick-view-overlay'),
    closePopup: document.querySelector('.close-popup'),
    quickViewButtons: document.querySelectorAll('.quick-view-btn'),
  };

  if (
    !elements.quickViewPopup ||
    !elements.quickViewContent ||
    !elements.quickViewLoader ||
    !elements.quickViewOverlay ||
    !elements.closePopup
  ) {
    console.error('Quick View elements not found in the DOM.');
    return;
  }

  elements.quickViewButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const handle = this.getAttribute('data-handle');
      if (!handle) {
        console.error('Product handle is missing.');
        return;
      }
      loadProductData(handle);
    });
  });

  function waitForFunction(functionName, callback, timeout = 5000, interval = 100) {
    const startTime = Date.now();

    function checkFunction() {
      if (typeof window[functionName] === 'function') {
        callback(window[functionName]);
      } else if (Date.now() - startTime < timeout) {
        setTimeout(checkFunction, interval);
      } else {
        console.warn(`⚠️ ${functionName}() does not match`);
      }
    }

    checkFunction();
  }

  const loadProductData = async (handle) => {
    try {
      elements.quickViewLoader.style.display = 'block';
      elements.quickViewContent.style.display = 'none';
      elements.quickViewPopup.style.display = 'block';
      elements.quickViewOverlay.style.display = 'block';

      const response = await fetch(`/products/${handle}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const htmlText = await response.text();
      displayProductData(htmlText);
    } catch (error) {
      console.error('Failed to load product data:', error);
    } finally {
      elements.quickViewLoader.style.display = 'none';
      elements.quickViewContent.style.display = 'block';
    }
  };

  const displayProductData = (data) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');

    const productInfoWrapper = doc.querySelector('.product__info-wrapper');
    if (!productInfoWrapper) {
      throw new Error('Product info wrapper not found in the fetched document.');
    }

    const productImage = doc.querySelector('.product__media img');
    const imageUrl = productImage ? productImage.src : 'https://placehold.co/400';

    // 2026-10-26: Refill-PDPs nutzen die neue Buybox (main-product-refill, Namespace rfl). Ihre Logik
    // haengt am Wrapper [data-rfl] und an refill-buybox.js/.css -> Wrapper nachbauen, Assets bei Bedarf
    // nachladen und initialisieren. FAQ-Drawer und Bewertung entfallen in der Schnellansicht.
    const rflSource = doc.querySelector('[data-rfl]');
    let infoHtml = productInfoWrapper.innerHTML;
    if (rflSource) {
      // FAQ entfaellt; Bewertung bleibt (in der Schnellansicht nicht klickbar). Das Info-Popup (Kuendbar/Keimgarantie)
      // liegt ausserhalb des Info-Wrappers -> mitnehmen, alte Schnellansicht-Popups vorher entfernen.
      productInfoWrapper.querySelectorAll('[data-rfl-faq]').forEach((el) => el.remove());
      document.querySelectorAll('[data-rfl-modal][data-rfl-qv-modal]').forEach((el) => el.remove());
      const rflModal = rflSource.querySelector('[data-rfl-modal]');
      if (rflModal) rflModal.setAttribute('data-rfl-qv-modal', '');
      infoHtml = `<div class="rfl rfl--qv" data-rfl data-section="qv-${Date.now()}">${productInfoWrapper.innerHTML}${rflModal ? rflModal.outerHTML : ''}</div>`;
      const css = doc.querySelector('link[href*="refill-buybox.css"]');
      if (css && !document.querySelector('link[href*="refill-buybox.css"]')) {
        const l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = css.getAttribute('href');
        document.head.appendChild(l);
      }
      const js = doc.querySelector('script[src*="refill-buybox.js"]');
      setTimeout(() => {
        if (window.RflBuybox && typeof window.RflBuybox.boot === 'function') {
          window.RflBuybox.boot();
        } else if (js && !document.querySelector('script[src*="refill-buybox.js"]')) {
          const s = document.createElement('script');
          s.src = js.getAttribute('src');
          document.head.appendChild(s);
        }
      }, 0);
    }

    elements.quickViewContent.innerHTML = `
          <div class="quick-view-popup__image">
            <img src="${imageUrl}" alt="product-image" loading="lazy" width="400" height="400">
          </div>
          <div class="quick-view-popup__info">
            ${infoHtml}
          </div>
        `;

    waitForFunction('ratingSnippet', (ratingSnippet) => {
      /*
      ratingSnippet('ruk_rating_snippet', {
        store: 'ingarden-eu.myshopify.com',
        mode: 'default',
        color: '#c2fc82',
        linebreak: false,
        text: '',
        singularText: 'Bewertung',
        lang: 'de',
        usePolaris: true,
        showEmptyStars: false,
      });*/
      
    });

    // elements.quickViewContent.innerHTML = productInfoWrapper.innerHTML;

    elements.quickViewLoader.classList.add('hidden');
    elements.quickViewContent.classList.remove('hidden');
    elements.quickViewOverlay.classList.remove('hidden');
    elements.quickViewPopup.classList.add('active');
    elements.quickViewOverlay.classList.add('active');
    document.body.classList.add('no-scroll');

    attachCloseOnAddToCart();
  };

  function attachCloseOnAddToCart() {
    const addToCartBtnAll = elements.quickViewContent.querySelectorAll("[name='add']");

    if (addToCartBtnAll.length > 0) {
      addToCartBtnAll.forEach((addToCartBtn) => {
        addToCartBtn.addEventListener('click', function () {
          setTimeout(closeQuickView, 500);
        });
      });
    }
  }

  function closeQuickView() {
    elements.quickViewPopup.classList.remove('active');
    elements.quickViewOverlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  // Refill-Buybox in der Schnellansicht: nach erfolgreichem Hinzufuegen schliessen (Side Cart oeffnet sich)
  document.addEventListener('rfl:added', () => setTimeout(closeQuickView, 300));

  elements.closePopup.addEventListener('click', closeQuickView);
  elements.quickViewOverlay.addEventListener('click', closeQuickView);

  document.addEventListener('click', function (event) {
    if (
      !elements.quickViewPopup.contains(event.target) &&
      !event.target.closest('.quick-view-btn') &&
      !event.target.closest('[data-rfl-modal]')
    ) {
      closeQuickView();
    }
  });
});
